import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "f-ta-c" }

import { ref, reactive, h, unref } from 'vue';
import { GbTables } from '@/components/GbTables';
import { useGbTable } from '@/hooks/useGbTable';
import { ElMessage } from 'element-plus';
import { formatTools } from '@/utils';

import { GetPayplanListApi } from '@/apis/contract/contract.draft.api';

import PlanDetailDialog from './payplanDetail.vue';
import BillDialog from './billDetail.vue';

// 添加多语言支持
import { useLocales } from '@/hooks/useLocales';

export default /*#__PURE__*/_defineComponent({
  setup(__props, { expose }) {

const { t } = useLocales();

const planDetailRef = ref<InstanceType<typeof PlanDetailDialog>>();
const billDialogRef = ref<InstanceType<typeof BillDialog>>();

const { fAmount, fDate } = formatTools();
const { register, tableObject } = useGbTable();

const payPlans = ref<any[]>([]);
const state = reactive({
	load: false,
});

const tabColumns = reactive<any[]>([
	{ field: 'name', label: t('performs.table.planName', '计划名称'), columnWidth: '150' },
	{ field: 'pay_condition', label: t('performs.table.planCondition', '款项条件') },
	{ field: 'amount', label: t('bill.applyAmount', '申请金额'), columnWidth: '120', align: 'right' },
	{ field: 'scale', label: t('performs.table.planScale', '申请比例'), columnWidth: '80', align: 'right' },
	{ field: 'pay_date', label: t('performs.table.plannedPayDate', '计划付款日期'), columnWidth: '100', align: 'center' },
	{ field: 'remark', label: t('categorys.table.remark', '备注'), columnWidth: '200', align: 'left' },
	{ field: 'action', label: t('contractList.table.action', '操作'), columnWidth: '120', align: 'left' },
]);

const actions = {
	detail: (row: any) => {
		unref(planDetailRef)?.openDialog(row.id);
	},
	bill: (row: any) => {
		unref(billDialogRef)?.openDialog(row.id);
	},
};

const methods = {
	setPlanList: async (contractdId: string) => {
		state.load = true;
		const { succeeded, errors, data } = await GetPayplanListApi(contractdId);
		state.load = false;

		if (!succeeded) {
			ElMessage.error(`读取付款计划列表数据出错，可能的原因是：${errors}`);
		} else {
			payPlans.value = data || [];
		}
	},
	clearPlan: () => {
		payPlans.value = [];
	},
};

expose({ ...methods });

return (_ctx: any,_cache: any) => {
  const _component_el_button = _resolveComponent("el-button")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_unref(GbTables), {
      columns: _unref(tabColumns),
      data: payPlans.value,
      "show-paged": false,
      onRegister: _unref(register)
    }, {
      scale: _withCtx(({ row }) => [
        _createElementVNode("span", null, _toDisplayString(row.scale) + " %", 1)
      ]),
      pay_date: _withCtx(({ row }) => [
        _createElementVNode("span", null, _toDisplayString(_unref(fDate)(row.pay_date)), 1)
      ]),
      amount: _withCtx(({ row }) => [
        _createElementVNode("span", null, _toDisplayString(_unref(fAmount)(row.amount)), 1)
      ]),
      action: _withCtx(({ row }) => [
        _createElementVNode("div", _hoisted_1, [
          _createVNode(_component_el_button, {
            size: "small",
            link: "",
            type: "primary",
            onClick: ($event: any) => (actions.detail(row))
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_unref(t)('performs.buttons.detail', '详细')), 1)
            ]),
            _: 2
          }, 1032, ["onClick"]),
          _createVNode(_component_el_button, {
            size: "small",
            link: "",
            type: "warning",
            onClick: ($event: any) => (actions.bill(row))
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_unref(t)('performs.buttons.bills', '付款单')), 1)
            ]),
            _: 2
          }, 1032, ["onClick"])
        ])
      ]),
      _: 1
    }, 8, ["columns", "data", "onRegister"]),
    _createVNode(PlanDetailDialog, {
      ref_key: "planDetailRef",
      ref: planDetailRef
    }, null, 512),
    _createVNode(BillDialog, {
      ref_key: "billDialogRef",
      ref: billDialogRef
    }, null, 512)
  ], 64))
}
}

})